import { useListItem, useMergeRefs } from '@floating-ui/react';
import * as React from 'react';
import styled from 'styled-components';

import { nameof } from '../../../utils/nameof';
import { Icon } from '../../icon/icon';
import { Stack } from '../../stack/stack';
import { MenuContext } from '../context/menu-context';
import { MenuItemButton } from './styles';

type Props = {
  label: string;
  disabled?: boolean;
};

const ExpandableMenuItem = React.forwardRef<HTMLButtonElement, Props>((props, forwardedRef) => {
  const menu = React.useContext(MenuContext);
  const item = useListItem({ label: props.label });
  const isActive = item.index === menu.activeIndex;

  return (
    <MenuItemButton
      {...props}
      disabled={props.disabled}
      ref={useMergeRefs([item.ref, forwardedRef])}
      role="menuitem"
      tabIndex={isActive ? 0 : -1}
      {...menu.getItemProps()}
    >
      <Stack alignItems="center" direction="row" flex={1} spacing={4}>
        <Label>{props.label}</Label>
        <Icon aria-hidden={true} icon={['fas', 'caret-right']} />
      </Stack>
    </MenuItemButton>
  );
});

ExpandableMenuItem.displayName = nameof({ ExpandableMenuItem });

const Label = styled.span`
  flex: 1;
`;

export { ExpandableMenuItem };
